<template>
  <b-modal
    id="selected_menu_item"
    title="Choose Your Preferences"
    class="beautify"
    hide-footer
  >
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(add_to_cart)">
        <b-row class="mb-1">
          <b-col cols="5" class="mt-2">
            <label><b>Enter Quantity:</b></label>
          </b-col>

          <b-col cols="7">
            <number-input
              v-model="quantity"
              :min="1"
              inline
              controls
            ></number-input>
          </b-col>
        </b-row>

        <ValidationProvider
          v-if="menu_item.attributes.option_types.data.length > 0"
          rules="required"
          v-slot="{ failed }"
          v-for="(option_type, index) in menu_item.attributes.option_types.data"
          :key="option_type.id"
        >
          <label><b>Choose {{ capitalize(option_type.attributes.name) }}</b></label><span class="form-error">{{ failed ? '1 required' : ''}}</span>

          <b-container>
            <b-row
              v-for="menu_option in option_type.attributes.menu_options"
              :key="menu_option.id"
            >
              <b-col cols="5">
                <b-form-radio
                  :value="{ option_type_id: option_type.id, menu_option_id: menu_option.id }"
                  v-model="order_item_options[index]"
                >
                  {{ capitalize(menu_option.name) }}
                </b-form-radio>
              </b-col>

              <b-col>$ {{ menu_option.price }}</b-col>
            </b-row>
          </b-container>
        </ValidationProvider>

        <label v-if="menu_item.attributes.add_ons.data.length > 0"><b>Add Ons</b></label>

        <b-container v-if="menu_item.attributes.add_ons.data.length > 0">
          <b-row
            v-for="(add_on, index) in menu_item.attributes.add_ons.data"
            :key="index"
          >
            <b-col cols="5">
              <b-form-checkbox
                :value="{ menu_add_on_id: add_on.id }"
                :name="add_on.attributes.name"
                v-model="order_item_add_ons[index]"
              >
                {{ add_on.attributes.name }}
              </b-form-checkbox>
            </b-col>

            <b-col cols="7">$ {{ add_on.attributes.price }}</b-col>
          </b-row>
        </b-container>

        <label class="mt-1"><b>Special Instruction</b></label>

        <b-row>
          <b-col class="mb-4">
            <p class="desc-note mb-1">Please let us know if we need to avoid anything or you don't want to add.</p>

            <b-form-textarea
              id="textarea"
              placeholder="Eg. No mushrooms"
              v-model="instructions"
              size="sm"
            ></b-form-textarea>
          </b-col>
        </b-row>

        <div class="border-bottom my-3"></div>

        <div class="float-right">
          <b-button squared type="submit" variant="outline-success">Add to Cart</b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
export default {
  props: {
    menu_item: Object,
  },

  data() {
    return {
      quantity: 1,
      order_item_options: [],
      order_item_add_ons: [],
      instructions: '',
    }
  },

  methods: {
    add_to_cart() {
      this.$store.dispatch("add_to_cart", {
        order_id: $cookies.get('order_id'),
        cart: {
          status: 0,
          order_items_attributes: [{
            menu_item_id: this.menu_item.id,
            quantity: this.quantity,
            instructions: this.instructions,
            order_item_options_attributes: this.order_item_options,
            order_item_add_ons_attributes: this.order_item_add_ons
          }]
        }
      })
      this.quantity = 1
      this.$root.$emit('bv::hide::modal', 'selected_menu_item', '#btnShow')
    },
    capitalize(title) {
      return title.charAt(0).toUpperCase() + title.slice(1)
    },
  },

  beforeDestroy() {
    this.quantity = 1
    this.order_item_options = []
    this.order_item_add_ons = []
  },
}
</script>

<style scoped>
  .form-error {
    color: #D9534F;
    padding: 5px;
  }
</style>
